import Axios from "./axios";

const endpoint = "/api/order";

export default {
  //발주 등록
  //{"orderData": [{"constructionId": 0,"orderId": 0,"orderName": "string","partName": "string","rebarList": ["string"]}]}
  orderCreate: (data) => Axios.post(`${endpoint}/create`, data),

  //발주 삭제
  //{"orderId":[0]}
  orderDelete: (data) => Axios.post(`${endpoint}/delete`, data),

  //발주 상세
  //{"constructionId": 0,"constructionName": "string","endDate": "string","orderId": 0,
  //"orderName": "string","partName": "string","startDate": "string","userId": 0}
  orderDetail: (data) => Axios.post(`${endpoint}/detail`, data),

  //발주목록 조건별 조회
  //{"constructionId": 0,"constructionName": "string","endDate": "string",
  //"orderId": 0,"orderName": "string","partName": "string","startDate": "string","userId": 0}
  orderFilterList: (data) => Axios.post(`${endpoint}/filter-list`, data),

  //발주 수정
  //{"constructionId": 0,"orderId": 0,"orderName": "string","partName": "string","rebarList": ["string"]}
  orderUpdate: (data) => Axios.post(`${endpoint}/update`, data),

  /**
   * 발주목록 전체 조회
   * @param {Number} constructionId
   * @param {Text} smsType sms 타입
   * @param {Text} type 타입
   * @param {Text} keyword 검색 조건
   * @param {Text} startDate 시작 날짜
   * @param {Text} endDate 종료 날짜
   * @param {Number} currentPage 현재 페이지
   * @param {Array} order 정렬 순서
   * @param {Number}pagingCount	페이지 출력 갯수
   */
  orderTotalList: (data) => Axios.post(`${endpoint}/total-list`, data),

  orderWriteMemo: (data) => Axios.post(`${endpoint}/write-memo`, data),

  orderReadMemo: (data) => Axios.post(`${endpoint}/read-memo`, data),

  orderDeleteSingle: (data) => Axios.post(`${endpoint}/delete-single`, data),

  /**
   * 필터 리스트 조회
   * @param {Number} constructionId 현장번호
   * @returns
   */
  orderFilterListSearch: (data) => Axios.post(`${endpoint}/search-list`, data),
};
